import * as Sentry from '@sentry/browser';
import { httpError } from './errorHandlerSlice';

export const handleHTTPError = (error: any, dispatch: AppDispatch, errorMessage?: string) => {
  const response = error?.response ?? {};
  const data = response?.data ?? {};
  const graphQLError = Array.isArray(data?.errors) && data.errors.length > 0 ? data.errors[0] : {};
  const graphQLErrorExtensions = graphQLError?.extensions ?? {};

  const errorMessageFromAction = error?.action?.actionData?.errorMessage;
  const correlationId =
    error?.correlationId ||
    response?.headers?.['correlation-id'] ||
    response?.headers?.correlationId;

  let message =
    error.status === 400
      ? errorMessage || error?.response?.data?.message || error?.message
      : data?.message ||
        graphQLErrorExtensions?.errorMessage ||
        graphQLError?.message ||
        errorMessageFromAction ||
        '';

  const errCode =
    error.status === 400
      ? 400
      : ((data?.code || graphQLErrorExtensions?.code || graphQLErrorExtensions?.classification) as
          | string
          | number
          | undefined);

  try {
    const sentryMsg = message || 'HTTP Error';
    Sentry.captureMessage(
      correlationId ? `${sentryMsg} [correlation-id: ${correlationId}]` : sentryMsg,
    );
  } catch {}

  if (error?.action?.params === 'skipErrorModal') {
    message = '';
  }
  dispatch(
    httpError({
      msg: message,
      errorCode: errCode,
      correlationId,
    }),
  );
};
